import { connect } from 'react-redux';

import withOverlayControls from 'eventbrite_design_system/structure/hoc/withOverlayControls';

import {
    LocationAutocompleteInternal,
    getLocationSuggestions,
} from '@eb/destination-utils';

import { searchLocationSuggestions as searchLocationSuggestionsAction } from '../actions/location';

const _mapStateToProps = (state) => ({
    currentPlace: state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    isBBoxSearch: !!state.search.eventSearch.bbox,
    isUseCurrentLocationEnabled: state.app.featureFlags.useCurrentLocation,
    isUsingCurrentLocation: state.location.isUsingCurrentLocation,
    isWaitingForLocation: state.location.isWaitingForLocation,
    locationSuggestions: getLocationSuggestions(
        state.location,
        state.app.featureFlags.useCurrentLocation,
    ),
    placeId: state.location.placeId,
    latitude: state.location.latitude,
    longitude: state.location.longitude,
});

const _mapDispatchToProps = {
    handleLocationSuggestionChange: searchLocationSuggestionsAction,
};

export default withOverlayControls(
    connect(
        _mapStateToProps,
        _mapDispatchToProps,
    )(LocationAutocompleteInternal),
);
